import {map} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {ApiService} from './api';

@Injectable({providedIn: 'root'})
export class PccsService {
  path: string = '/api';
  constructor(private apiService: ApiService) {}

  getPccs(partnerId: any) {
    return this.apiService.get(`${this.path}/v2/airlines/${partnerId}/restricted_pccs`).pipe(
      map((response: any) => {
        return response.data;
      }),
    );
  }

  setPccs(partnerId: any, pccPostData: any) {
    /* {
      data: pccPostData,
    } */
    return this.apiService
      .post<{ data: { errors?: { status: number; messages: string[] } } }>(`${this.path}/v2/airlines/${partnerId}/restricted_pccs`, pccPostData);
  }

  deletePcc(partnerId: any, pcc: string, userId: number) {
    return this.apiService
      .deleteBody(`${this.path}/v2/airlines/${partnerId}/restricted_pccs/${pcc}`, {user_id: userId});
  }
}
